import React from "react";
import {
    Button,
    Dropdown, DropdownDivider,
    DropdownHeader,
    DropdownItem,
    DropdownMenu,
    Menu
} from "semantic-ui-react";
import {observer} from "mobx-react-lite";
import AddUserButton from "../AddUserButton/AddUserButton";
import usersStore from "../UsersStore";
import authStore from "../../Stores/AuthStore";
import adminService from "../AdminService";
import tokenConverterStore from "../TokenConverterStore";
import analyticsStore from "../AnalyticsStore";
import stockWebhookTesterStore from "../EventTesterStore";
import {NavLink} from "react-router-dom";
import {routeName} from "../AdminRouter";
import subscriptionCheckerStore from "../SubscriptionChecker/SubscriptionCheckerStore";
import productInfoStore from "../ProductInfoStore";
import xmlGenerationDebugStore from "../XmlGenerationDebugStore";

function AdminMenu() {
    return (
        <>
            <Menu>
                <Dropdown item icon='wrench'>
                    <DropdownMenu>
                        <DropdownHeader>Выгрузки</DropdownHeader>
                        <DropdownItem onClick={() => adminService.createJobs()}>Создать задачи</DropdownItem>
                        <DropdownItem onClick={() => xmlGenerationDebugStore.show()}>Создать задачу для дебага</DropdownItem>
                        <DropdownItem onClick={() => adminService.runJobs()}>Запустить</DropdownItem>
                        <DropdownItem onClick={() => adminService.stopJobs()}>Остановить</DropdownItem>
                        <DropdownItem onClick={() => adminService.deleteAllJobs()}>Удалить все задачи</DropdownItem>
                        <DropdownDivider/>
                        <DropdownHeader>Разное</DropdownHeader>
                        <DropdownItem onClick={() => adminService.actualizeOrderStatesMapping()}>Актуализировать маппинг
                            статусов заказа</DropdownItem>
                        <DropdownItem onClick={() => productInfoStore.show()}>Запрос товара по урлу</DropdownItem>
                        <DropdownItem onClick={() => analyticsStore.switch()}>Аналитика</DropdownItem>
                        <DropdownItem onClick={() => tokenConverterStore.show()}>Конвертер токенов</DropdownItem>
                        <DropdownItem onClick={() => stockWebhookTesterStore.show()}>Тестрование webhook</DropdownItem>
                        <DropdownItem onClick={() => adminService.actualizeRequiredPriceInTemplates()}>Актуализировать
                            обязательность цены в шаблонах</DropdownItem>
                        <DropdownItem onClick={() => subscriptionCheckerStore.show()}>Проверка подписок</DropdownItem>
                        <DropdownItem onClick={() => usersStore.runUsersDataUpdate()}>Запустить обновление
                            данных</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Menu.Item
                    as={NavLink}
                    to={'/' + routeName + '/users'}
                    icon='user'
                    content='Пользователи'
                />
                <Menu.Item
                    as={NavLink}
                    to={'/' + routeName + '/templatesV2'}
                    icon='file alternate'
                    content='Шаблоны V2'
                />
                <Menu.Item>
                    <a href={"/ninjaPortal/jobs"} target="_blank">Hangfire</a>
                </Menu.Item>
                <Menu.Item>
                    <a href={"https://seq.unitxml.ru"} target="_blank">Logger</a>
                </Menu.Item>
                <Menu.Item>
                    <a href={"https://grafana.unitxml.ru"} target="_blank">Grafana</a>
                </Menu.Item>
                <Menu.Item>
                    <a href={"https://gitlab.com/someprojects2020/sklad/avitointegrator"} target="_blank">GitLab</a>
                </Menu.Item>
                <Menu.Item>
                    <a href={"https://apps.moysklad.ru/cabinet/reports/summary"} target="_blank">ЛК вендора</a>
                </Menu.Item>
                <Menu.Item>
                    <AddUserButton/>
                </Menu.Item>
                <Menu.Item position={'right'}>
                    <Button basic color={'red'} onClick={() => authStore.logOut()}>Выход</Button>
                </Menu.Item>
            </Menu>
        </>
    )
}

export default observer(AdminMenu);
